import {useState, useEffect} from 'react';
import  {useDispatch, useSelector} from 'react-redux';
import { Grid, Button, Typography } from '@mui/material';
import ImageGalleryHolder from 'core/components/image-gallery/ImageGalaryHolder';
import { setProductLinkImageModal } from 'store/slice/DmpSlice';


export default function LinkImageActionImpl(){

    const dispatch = useDispatch();
    const clickToAction = () => {
        dispatch(setProductLinkImageModal(false));
    }
    return (
        <>
        <ImageGalleryHolder label="Continue" clickToAction={clickToAction}/>
        </>
    )
}